module.exports = ".ColAbandono {\r\n    -webkit-box-pack: stretch;\r\n            justify-content: stretch;\r\n    display: inline-block;    \r\n    }"